/**
 * @Author: Zewei
 * @Date:   2018-01-22T09:58:52+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-28T13:06:01+08:00
 */

import { UserConstants } from '../constants/user-constants'

const initState = {
    submitting: false
};

export default function user (state = initState, action) {
    switch(action.type){
        case UserConstants.ActionTypes.ADD:
            return {...state, username: action.username, email: action.email};
        case UserConstants.ActionTypes.DELETE:
            return {...state};
        case UserConstants.ActionTypes.CHANGESUBMITTING:
            return {...state, ...action.payload};
        case UserConstants.ActionTypes.LOGINSUCCESS:
            return {...state, ...action.payload};
        case UserConstants.ActionTypes.LOGINFAILURE:
            return {...state, ...action.payload};
        case UserConstants.ActionTypes.LOGOUTSUCCESS:
            return {...state, ...action.payload};
        case UserConstants.ActionTypes.LOGOUTFAILURE:
            return {...state, ...action.payload};
        case UserConstants.ActionTypes.FETCHUSERSUCCESS:
            return {...state, ...action.payload};
        case UserConstants.ActionTypes.FETCHUSERAUTHSUCCESS:
            return {...state, ...action.payload};
        case UserConstants.ActionTypes.FETCHUSERMOBILEAUTHSUCCESS:
            return {...state, ...action.payload};
        case UserConstants.ActionTypes.FETCHAUTHSUCCESS:
            return {...state, ...action.payload};
        case UserConstants.ActionTypes.FETCHAUTHFAILURE:
            return {...state, ...action.payload};
        default:
            return {...state};
    }
}



// WEBPACK FOOTER //
// ./src/reducers/user-reducer.js